import { AppNS } from 'app';
import { getDuration } from 'app/ui_v2/helpers/parseDate';

import { Box, SxProps, Theme, useTheme } from '@mui/material';

export interface SubmissionTimeProps {
  data: AppNS.JobEventReport;
}

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    warning: {
      color: theme.palette.error.main,
    },
  };
};

export default function SubmissionTime(props: SubmissionTimeProps) {
  const { data } = props;

  const theme = useTheme();

  if (data.submissionTime === null || data.submissionTime === undefined) {
    return <>N/A</>;
  }

  const styles = getStyles(theme);
  return <Box sx={!data.submissionTimeMet ? styles.warning : {}}>{getDuration(data.submissionTime * 1000)}</Box>;
}
